export default {
  paymentSystems: [],
  paymentMethods: [],
  currencies: [],
  countries: [],
  isLoading: false,
};
